import type { App } from 'vue'
import type { Router } from 'vue-router'
import vuetify from './vuetify'
import GTag from '@/plugins/gtag'

export function registerPlugins(app: App, router: Router) {
  app.use(vuetify)
  app.use(GTag, router)
}
